<template lang="">
  <div>
    <div class="mt-4">
      <div class="text-medium-x leading-5 font-bold font-MEDIUM text-theme-black-850">可用短信余额</div>
      <p class="mt-4 text-theme-black-850 text-medium">
        <span class="text-medium leading-5 text-danger mr-2 font-semibold">{{balance}}</span>条
        <el-button v-if="!isSufficient && !isPersonal" class="ml-2" type="text" size="small" @click="refresh">刷新</el-button>
      </p>
      <p class="mt-2" v-if="!isSufficient && !isPersonal">
        <span class="text-medium leading-6 text-danger mr-2 font-semibold">可用短信发送条数不足，请先</span>
        <el-button type="text" size="small" @click="handleDispense">去分配</el-button>
      </p>
      <p class="mt-2" v-if="isPersonal && !isSufficient">
        <span class="text-medium leading-6 text-danger mr-2 font-semibold">可用短信发送条数不足，请先</span>
        <el-button type="text" size="small" @click="handlePayment">去购买</el-button>
      </p>
    </div>
  </div>
</template>
<script>
import GlobalConfig,{ AuthConfig } from '@/global/config'
import { toBasePlatform } from '@/assets/js/base-platform'
import { mapGetters } from 'vuex'
export default {
  data(){
    return{
      balance:100, //余额
      isSufficient: true, // 余额是否充足
    }
  },
  computed:{
    ...mapGetters(['userInfo']),
    // 是否是个人版
    isPersonal(){
      return [AuthConfig.Personal,AuthConfig.PersonalPlus].includes(GlobalConfig.getAuthCode())
    }
  },
  methods:{
    // 去分配
    handleDispense(){

    },
    // 刷新
    refresh(){

    },
    // 去购买
    handlePayment(){
      const {isQY,isAdmin} = this.userInfo
      // 清研企业并且为管理员进入新版短信管理 反之去老版
      if(isQY && isAdmin){
        const url = this.$router.resolve({path:'/company/funds/text-message'})
        window.open(url.href, '_blank')
      }else{
        const q = { token: GlobalConfig.getBaseToken(), companyid: GlobalConfig.getCompanyId() }
        toBasePlatform('/company/funds/textmessage', q)
      }
    }
  }
}
</script>
<style lang="">
  
</style>